import { Resource, ResourceType, useResource } from 'json-api-hooks';
import { useWatch } from 'react-hook-form';

import { FormFieldAttribute, FormFieldDefinition } from '../ResourceForm';

const useFormFieldCondition = (resource: Resource | undefined, formField: FormFieldDefinition) => {
  const formValues = useWatch() as Record<FormFieldAttribute<ResourceType>, string>;
  const [session] = useResource({ id: '', type: 'sessions' });

  const condition = formField.if;

  if (!condition) {
    return true;
  }

  if (!session) {
    return false;
  }

  return condition({ resource, session, formValues });
};

export default useFormFieldCondition;
